<template>
    <v-container fluid class="content-container">
        <div style="width: 100%" class="text-center">
            <v-btn :loading="isMoreLoading" color="primary" @click="loadMore">
                Show next {{ showNext }}
            </v-btn>
        </div>
    </v-container>

</template>
<script>
export default {
    methods: {
        loadMore() {
            this.$emit('loadMore');
        }
    },
    props: {
        isMoreLoading: {
            type: Boolean,
            required: true,
            default: false
        },
        showNext: {
            type: Number,
            required: true,
            default: ''
        }
    }
}
</script>